import cx from "classnames";
import { IonContent, IonLabel, IonPage } from "@ionic/react";
import { shallow } from "zustand/shallow";

import s from "./PurchaseWeb.module.scss";
import {
  useWebUserPaymentProvider,
  useWebUserProvider,
} from "../../CommonStores/user/provider";
import { useWebUserStore } from "../../CommonStores/user/users";
import brandLogo from "../../../Common/assets/logo/wl-woodmark-logo-rev.svg";
import { WLLoader } from "../../../Common/components/WLLoader/WLLoader";
import WLDialog from "../../components/WLDialog/WLDialog";
import { useFailedPaymentShowBannerProvider } from "../../CommonStores/failedPaymentOffer/failedPaymentOfferProvider";
import { useWLConfigProvider } from "../../CommonStores/wlConfig/useWLConfigProvider";
import {
  useSuperAndMysteryGiveAwayProvider,
  useSuperGiveAwayRunningGiveawayProvider,
} from "../../CommonStores/giveaways/useGiveAwaysProvider";
import { useWLLoaderStore } from "../../../Common/components/WLLoader/store";
import PaymentV2 from "./PaymentV2/PaymentV2";
import { useEffect, useMemo, useRef } from "react";
import { isNull } from "lodash";

const PurchaseWeb = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const userId = searchParams.get("userId") as string;
  useFailedPaymentShowBannerProvider();
  useWLConfigProvider();
  useSuperAndMysteryGiveAwayProvider();
  useSuperGiveAwayRunningGiveawayProvider();

  const [stripeActiveSubscription] = useWebUserStore(
    (state) => [state.stripeActiveSubscription],
    shallow
  );

  const { inValidUserRequest, isLoadingProviders } = useWebUserProvider({
    userId,
  });

  useWebUserPaymentProvider();

  const { isLoading } = useWLLoaderStore();

  const hasLoadedWithPaymentIssueRef = useRef(false);

  // Prevent unmounting payment component
  const hasPaymentIssueLoaded = useMemo(() => {
    if (hasLoadedWithPaymentIssueRef.current === true) {
      return true;
    } else {
      hasLoadedWithPaymentIssueRef.current =
        !isLoadingProviders &&
        !isLoading &&
        !inValidUserRequest &&
        stripeActiveSubscription !== undefined &&
        !isNull(stripeActiveSubscription) &&
        stripeActiveSubscription.status === "past_due" &&
        stripeActiveSubscription.pause_collection === null;

      return hasLoadedWithPaymentIssueRef.current;
    }
  }, [
    isLoadingProviders,
    isLoading,
    inValidUserRequest,
    stripeActiveSubscription,
  ]);


  // Once we've committed to showing PaymentV2 (sticky via hasPaymentIssueLoaded),
  // force WLLoader off and keep it off — otherwise late toggles of
  // loadingAuthUser / isLoadingWLUser (re-fetches, listener jitter, etc.)
  // re-open the IonLoading on top of an already-rendered page.
  useEffect(() => {
    if (hasPaymentIssueLoaded && isLoading) {
      useWLLoaderStore.getState().setLoading(false);
    }
  }, [hasPaymentIssueLoaded, isLoading]);


  return (
    <IonPage className={s.page}>
      <IonContent className={cx(s.pageContent)} scrollY={true} fullscreen>
        <div className={s.body}>
          <img className={s.logo} src={brandLogo} alt="" loading="eager" decoding="async" />
          {!isLoadingProviders && !isLoading && inValidUserRequest ? (
            <div className={cx(s.invalid)}>
              <IonLabel>
                Invalid Membership link, please{" "}
                <a
                  className={s.contactLink}
                  href="https://winnerslocker.com.au/contact/"
                  target="_newTab"
                >
                  contact support
                </a>
              </IonLabel>
            </div>
          ) : hasPaymentIssueLoaded || (!isLoadingProviders && !isLoading) ? (
            <div className={s.boxContentV2}>
              <PaymentV2 />
            </div>
          ) : (
            <></>
          )}
        </div>
      </IonContent>
      <WLLoader />
      <WLDialog />
    </IonPage>
  );
};

export default PurchaseWeb;
